export default __webpack_public_path__ + "img/8.asset.eca5f236.jpeg";